import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-management',
  templateUrl: './plan-management.component.html',
  styleUrls: ['./plan-management.component.css']
})
export class PlanManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
